import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScripts } from '../../../helpers/Utils';

export function MasterLanguagePage(): React.ReactElement {
  const currentSecurity = useSecurity('Master', 'Language');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScripts([
        'Areas/Master/Scripts/Resources/en/res.Language.en.js',
        'Areas/Master/Scripts/Resources/en/Types.en.js',
        'Areas/Master/Scripts/Enums.js',
        'Areas/Master/Scripts/Language/Index.js',
      ]);
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
